module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av149-fd0093cdead2d3a6a25daf5269171f41.jpg";